"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useState } from "react";
import ImageLightbox from "./ImageLightbox";

interface AutoScrollSliderProps {
  images?: string[];
}

const defaultSlides = [
  "https://yefranchisees.b-cdn.net/frontend/Program-detail/photo.png",
  "https://yefranchisees.b-cdn.net/frontend/Program-detail/photo%20(1).png",
  "https://yefranchisees.b-cdn.net/frontend/Program-detail/bc_scroll_pct_3.png",
  "https://yefranchisees.b-cdn.net/frontend/Program-detail/photo%20(2).png",
  "https://yefranchisees.b-cdn.net/frontend/Program-detail/photo%20(3).png",
];

export default function AutoScrollSlider({
  images = defaultSlides,
}: AutoScrollSliderProps) {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  return (
    <div className="w-full overflow-hidden py-0 marquee-swiper">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={15}
        slidesPerView={3}
        loop
        speed={5000}
        allowTouchMove={false}
        autoplay={{
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        breakpoints={{
          0: { slidesPerView: 1.2 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="flex items-center"
      >
        {images.map((src, i) => (
          <SwiperSlide key={`${src}-${i}`}>
            <div className="bg-gray-100 rounded-[32px] shadow-md flex justify-center">
              <img
                src={src}
                className="w-full h-[250px] xl:h-[360px] md:h-[250px] object-cover rounded-[32px] cursor-pointer"
                alt="Slider Image"
                loading="lazy"
                onClick={() => setLightboxIndex(i)}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <ImageLightbox
        images={images}
        index={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
      />
    </div>
  );
}
